import { FC,createContext, useEffect, useState } from "react";
import { DiagnosisContextType, DiagnosisListType } from "./types";
import DiagnosisList from "./DiagnosisList";
export const DiagnosisContext = createContext<DiagnosisContextType>({
    list:[],
    setList:()=>{},
    edit:null,
    setEdit:()=>{}
})
const PatientDiagnosis:FC = ()=>{
    const [list,setList] = useState<DiagnosisListType[]>([])
    const [edit,setEdit] = useState<DiagnosisListType | null>(null)

useEffect(()=>{
  return ()=>{
    setList([])
    setEdit(null)
  }
},[])

    return (
    <DiagnosisContext.Provider value={{list,setList,edit,setEdit}}>
        <DiagnosisList/>
    </DiagnosisContext.Provider>
    )
}

export default PatientDiagnosis